module.exports = __webpack_public_path__ + "static/img/bg73.9cb9517e.png";